// Formats: '%,n', '$,n', '$x,n', 'f,n', 'i,n'
// operations: 'last(a)', prod(a,b), ratio(a,b)

export default {
  '***': {
    '***': {
      '***': [
        {
          metric: 100,
          inHeader: true,
          label: 'Ad Effect Score',
          rowType: 'demphasized',
          dataFormat: '.,0',
          reverseStat: false,
          minSampleSize: 0
        },
        {
          label: 'IN-MARKET POTENTIAL',
          rowType: 'hb0'
        },
        {
          label: 'BREAKTHROUGH',
          rowType: 'h0'
        },
        {
          metric: 101,
          label: 'In-Feed Total Recall',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false,
        },
        {
          metric: 102,
          label: 'In-Market Branded Recall',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          label: 'IMPACT',
          rowType: 'h0'
        },
        {
          metric: 103,
          label: 'Lift to Impression',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 104,
          label: 'Lift to Consideration',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 105,
          label: 'Net Actions',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 106,
          label: 'Talk about the ad with friends/family',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 107,
          label: 'Go online for more information',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 108,
          label: 'Follow the brand on social media',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 109,
          label: "Call for more information",
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 110,
          label: 'Go to a retail store that sells these services',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 111,
          label: "Purchase prod/services / Upgrade current service",
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          label: 'CREATIVE DIAGNOSTICS',
          rowType: 'hb0'
        },
        {
          label: 'BRANDING',
          rowType: 'h0'
        },
        {
          metric: 112,
          label: 'Brand Recognition',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 113,
          label: 'Ease of Branding - Excluding Logo/Brand Name',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 114,
          label: 'Brand Prominence',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 115,
          label: 'Unique to this Brand',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          label: 'VALUE PROPOSITION',
          rowType: 'h0'
        },
        {
          metric: 116,
          label: 'Different than what others offer',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 117,
          label: 'Good value for the money',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 118,
          label: 'Make me feel more connected',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 119,
          label: 'Good fit with my lifestyle',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 120,
          label: 'Provides user privacy & protection',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          label: 'APPEAL',
          rowType: 'h0'
        },
        {
          metric: 121,
          label: 'Likes',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: false
        },
        {
          metric: 122,
          label: 'Dislikes',
          rowType: 'd0',
          dataFormat: '%,1',

          reverseStat: true
        },
        {
          label: 'CREATIVE EFFICIENCY',
          rowType: 'hb0'
        },
        // Pathway
        {
          metric: 123,
          label: 'Brand Connection',
          rowType: 'dh0',
          dataFormat: 'idx',
          reverseStat: false
        },
        {
          metric: 124,
          label: 'Brand I want to be associated with',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 125,
          label: 'Meets my needs',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 126,
          label: 'Makes me feel good about the brand',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 127,
          label: 'Spoke directly to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 128,
          label: 'Reliable',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        // Pathway
        {
          metric: 129,
          label: 'Relevance',
          rowType: 'dh0',
          dataFormat: 'idx',
          reverseStat: false
        },
        {
          metric: 130,
          label: 'Relatable people/situations',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 131,
          label: 'Addresses important issues to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 132,
          label: 'Is relevant to me',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        // Pathway
        {
          metric: 133,
          label: 'Brand Reappraisal',
          rowType: 'dh0',
          dataFormat: 'idx',
          reverseStat: false
        },
        {
          metric: 134,
          label: 'Makes me think of the brand in a new way',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 135,
          label: 'Tells me something new about this brand',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        // Pathway
        {
          metric: 136,
          label: 'Brand Value',
          rowType: 'dh0',
          dataFormat: 'idx',
          reverseStat: false
        },
        {
          metric: 137,
          label: 'Brand I trust',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 138,
          label: 'Has innovative technology',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 139,
          label: "Provides unique features I can't get from others",
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 140,
          label: 'Understands my needs better than competitors',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 141,
          label: 'Has products that integrate well w/ other devices',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 142,
          label: 'Offers me the flexibility to connect anywhere',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 143,
          label: 'Better value for the money than competitors',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 144,
          label: 'Provides more unique offers than competitors',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 145,
          label: 'Has a fast network',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        // Pathway
        {
          metric: 146,
          label: 'Cognitive Connection',
          rowType: 'dh0',
          dataFormat: 'idx',
          reverseStat: false
        },
        {
          metric: 147,
          label: 'Informative',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 148,
          label: 'Clear',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 149,
          label: 'Confusing',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: true
        },
        {
          metric: 150,
          label: 'Credible from this brand',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 151,
          label: 'Good fit with brand',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 152,
          label: 'Presents information at a good pace',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        // Pathway
        {
          metric: 153,
          label: 'Emotional Connection',
          rowType: 'dh0',
          dataFormat: 'idx',
          reverseStat: false
        },
        {
          metric: 154,
          label: 'Puts its customers first',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 155,
          label: 'Inspiring',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 156,
          label: 'Reassuring',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 157,
          label: 'Heartwarming',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        // Pathway
        {
          metric: 158,
          label: 'Engagement',
          rowType: 'dh0',
          dataFormat: 'idx',
          reverseStat: false
        },
        {
          metric: 159,
          label: 'Clever',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 160,
          label: 'Unique',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 161,
          label: 'Entertaining',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 162,
          label: 'Humorous',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 163,
          label: 'Worth seeing again',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 164,
          label: 'Memorable',
          rowType: 'd0',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 165,
          label: 'Grabs my attention',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: false
        },
        {
          metric: 166,
          label: 'Irritating',
          rowType: 'd0i',
          dataFormat: '.,2',
          reverseStat: true
        },
        {
          label: 'BREAKTHROUGH POTENTIAL',
          rowType: 'hb0'
        },
        {
          metric: 167,
          label: 'Ignore the ad/not notice the ad at all',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 168,
          label: 'Notice the ad, but not pay much attention',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 169,
          label: 'Pause briefly to watch the ad',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 170,
          label: 'Watch the entire ad',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 171,
          label: 'Ease of describing ad to a friend tomorrow',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: 'OFFER RECALL & IMPACT',
          rowType: 'hb0'
        },
        {
          metric: 172,
          label: 'Recall offer in ad',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 173,
          label: 'Offer is relevant to me',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 174,
          label: 'Offer piques my interest',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          metric: 175,
          label: 'Offer is better than others seen recently',
          rowType: 'd0',
          dataFormat: '%,1',
          reverseStat: false
        },
        {
          label: '',
          rowType: 'eol'
        }
      ]
    },
  }
};



// WEBPACK FOOTER //
// ./src/app/configuration/Tmobile/config/components/scorecard/MetricsLabels/metricsLabels.js